import React from "react";
import Dialog from "@material-ui/core/Dialog";
import useStyles from "./styles";

const WHATSAPP_ICON =
  "https://km-landing.s3.ap-south-1.amazonaws.com/Images/wtsp-comm-icon.png";

export default function OpenPlayCommunityPopup({ open, city, onClose }) {
  const classes = useStyles();

  if (!city) {
    return null;
  }

  const handleGroupClick = (group) => {
    if (!group?.whatsappLink) {
      return;
    }

    window.open(group.whatsappLink, "_blank", "noopener,noreferrer");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.dialogPaper,
      }}
    >
      <div className={classes.popupWrapper}>
        {/* Close button */}
        <button
          type="button"
          className={classes.closeButton}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        {/* Popup heading */}
        <div className={classes.popupHeader}>
          <h3 className={classes.popupHeading}>{city.city} Groups</h3>
          {/* 
          <p className={classes.popupSubHeading}>
            Join the community that matches your game
          </p> */}
        </div>

        {/* Groups */}
        <div className={classes.groupGrid}>
          {city.groups?.map((group, index) => {
            const hasLink = Boolean(group.whatsappLink);

            return (
              <button
                type="button"
                key={`${group.name}-${index}`}
                className={classes.groupCard}
                onClick={() => handleGroupClick(group)}
                disabled={!hasLink}
                data-whatsapp-url={group.whatsappLink}
                data-group-name={group.name}
                data-city-name={city.city}
              >
                <img
                  src={WHATSAPP_ICON}
                  alt="WhatsApp"
                  className={classes.groupWhatsappIcon}
                />

                <div className={classes.groupContent}>
                  <div className={classes.groupName}>{group.name}</div>

                  {group.sport && (
                    <div className={classes.sportName}>{group.sport}</div>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        {(!city.groups || city.groups.length === 0) && (
          <div className={classes.noGroups}>
            Community groups will be available soon.
          </div>
        )}
      </div>
    </Dialog>
  );
}
